// extracted by mini-css-extract-plugin
module.exports = {"header":"FaHeaders_header__2ZLHk","syncBtn":"FaHeaders_syncBtn__2M1Ep","rightSection":"FaHeaders_rightSection__1yWoB","contentWrapper":"FaHeaders_contentWrapper__1LREo"};